/* eslint-disable no-useless-escape */
import { cache } from '@/utils';

// GDPR国家列表
export const GDPRCountry = [
  'AT',
  'BE',
  'BG',
  'CY',
  'HR',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'NL',
  'IS',
  'LI',
  'NO',
  'GB',
];

// GDPR or CCPA
export const ProtectionJurisdictions = [...GDPRCountry, 'US'];

/**
 * 从cookie中解析cookie授权记录
 */
export const getCookieConsent = () => {
  let CookieBotAuth = cache.getCookie('CookieConsent'); // Cookiebot授权记录
  let CookieInsAuth = cache.getCookie('CookieConsentIns'); // 自定义授权记录
  try {
    CookieBotAuth = CookieBotAuth
      ? JSON.parse(
          CookieBotAuth.replace(/%2c/g, ',')
            .replace(/'/g, '"')
            .replace(/([{\[,])\s*([a-zA-Z0-9_]+?):/g, '$1"$2":')
        )
      : null;
  } catch (e) {
    console.error('CookieBot授权解析JSON失败');
    CookieBotAuth = null;
  }

  try {
    CookieInsAuth = CookieInsAuth ? JSON.parse(CookieInsAuth) : null;
  } catch (e) {
    console.error('Cookie自定义授权解析JSON失败');
    CookieInsAuth = null;
  }

  return { CookieBotAuth, CookieInsAuth };
};
